// src/components/ui/shop/PurchaseResultModal.js
// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';

const PurchaseResultModal = ({show, onHide, success, message}) => {
  const {t} = useTranslation();
  if (!show) return null;

  return (
    <Overlay>
      <Modal>
        <Header>
          <Title>{success ? t('purchaseResult.successTitle') : t('purchaseResult.failureTitle')}</Title>
        </Header>
        <Content>
          <Message>{message}</Message>
        </Content>
        <Footer>
          <Button onClick={onHide}>{t('purchaseResult.okButton')}</Button>
        </Footer>
      </Modal>
    </Overlay>
  );
};

export default PurchaseResultModal;

// ======= Styled Components =======
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background-image: url(/assets/ui/container-bg.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  border-radius: 8px;
  width: 350px;
  max-width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`;

const Header = styled.div`
  padding: 16px;
`;

const Title = styled.h3`
  margin: 0;
  text-align: center;
`;

const Content = styled.div`
  padding: 16px;
  text-align: center;
`;

const Message = styled.p`
  margin: 0;
  font-size: 1rem;
`;

const Footer = styled.div`
  padding: 16px;
  display: flex;
  justify-content: center;
`;

const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;
